import { render } from "./SimpleCategories.vue?vue&type=template&id=08eb0409"
import script from "./SimpleCategories.vue?vue&type=script&lang=js"
export * from "./SimpleCategories.vue?vue&type=script&lang=js"

import "./SimpleCategories.vue?vue&type=style&index=0&id=08eb0409&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__